<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="300px"
  >
    <template v-slot:activator="{ on }" />
    <v-card>
      <v-card-title class="text-body-1">
        <span v-html="message" />
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="btnClick"
        >
          {{ $t('ConfirmModal.OK') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
//   props: {
//     message: {
//       type: String,
//       required: true
//     },
//     show: {
//       type: Boolean,
//       required: true
//     }
//   },
  data: () => ({
    // show: false
  }),
  computed: {
    ...mapState('global', {
      message: state => state.errorMessage,
      show: state => state.showError
    })
  },
  methods: {
    btnClick: function () {
    //   this.$emit('update:show', false)
      this.$store.commit('global/setShowError', false)
    }
  }
}
</script>
